module.exports = __webpack_public_path__ + "static/img/logo_44.7896859.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_44.png
// module id = FXqh
// module chunks = 1